import React, { useId } from 'react'

import {
  NeutralInverseWhiteColorType,
  OutlineColorType,
  SurfaceColorType,
} from '@ui/design-system/colors/colors'

type SquircleShapeProps = {
  color?: SurfaceColorType | NeutralInverseWhiteColorType
  size: number
  bgImage?: string | null
  bgImageOpacity?: number
}

const SQUIRCLE_PATH =
  'M1.90575 15.8059C3.54788 8.92673 8.92673 3.54788 15.8059 1.90575C26.4505 -0.63525 37.5494 -0.63525 48.1941 1.90575C55.0732 3.54788 60.452 8.92673 62.0942 15.8059C64.6353 26.4505 64.6353 37.5494 62.0942 48.1941C60.452 55.0732 55.0732 60.452 48.1941 62.0942C37.5494 64.6353 26.4505 64.6353 15.8059 62.0942C8.92673 60.452 3.54788 55.0732 1.90575 48.1941C-0.63525 37.5494 -0.63525 26.4505 1.90575 15.8059Z'

export const SquircleShape = ({ color, size, bgImage, bgImageOpacity = 1 }: SquircleShapeProps) => {
  const clipPathId = useId()

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 64 64'
      fill='none'
    >
      <defs>
        <clipPath id={clipPathId}>
          <path d={SQUIRCLE_PATH} />
        </clipPath>
      </defs>

      {color ? <path d={SQUIRCLE_PATH} fill={`var(--${color})`} /> : null}

      {bgImage ? (
        <image
          href={bgImage}
          x='0'
          y='0'
          width='64'
          height='64'
          preserveAspectRatio='xMidYMid slice'
          clipPath={`url(#${clipPathId})`}
          opacity={bgImageOpacity}
        />
      ) : null}
    </svg>
  )
}

export const SquircleOutline = ({ color, size }: { color?: OutlineColorType; size: number }) =>
  color ? (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 64 64'
      fill='none'
    >
      <path
        d='M15.9219 2.3916C26.4902 -0.13118 37.5098 -0.13118 48.0781 2.3916C54.7738 3.98995 60.0089 9.22615 61.6074 15.9219C64.1302 26.4902 64.1302 37.5098 61.6074 48.0781C60.0089 54.7737 54.7737 60.0089 48.0781 61.6074C37.5098 64.1302 26.4902 64.1302 15.9219 61.6074C9.22615 60.0089 3.98995 54.7738 2.3916 48.0781C-0.13118 37.5098 -0.13118 26.4902 2.3916 15.9219C3.98997 9.22605 9.22605 3.98997 15.9219 2.3916Z'
        stroke={`var(--${color})`}
      />
    </svg>
  ) : null
